<template>
  <div class="csr-input-aside-return-texts">
    <InputSelect v-bind="{...$attrs, ...$props, span:6}" class="special-emphasize-input-text"/>
    <div  class="next">
      <span>Type&nbsp;</span>
      <span class="strong">{{typeName(this.type)}}</span>
    </div>

  </div>
</template>

<script>
import InputSelect from './InputSelect'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'InputTagWithOrderType',
  components: {
    InputSelect
  },
  props: {
    defaultValue: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    ...mapState('edit', {
      type: 'type'
    }),
    ...mapGetters({
      typeName: 'orderTypeName'
    })
  },
  methods: {}
}
</script>
